module.exports = __webpack_public_path__ + "8b688ae187d078bfba7c139fb454e3b6.pdf";